import equals from "fast-deep-equal/es6";

import { StreamCurrentValueClient } from "@formant/core/client/StreamCurrentValueClient";
import { duration } from "@formant/core/model/duration";
import { IScopeFilter } from "@formant/core/model/IScopeFilter";
import { IStreamCurrentValue } from "@formant/core/model/IStreamCurrentValue";
import { IStreamCurrentValueQuery } from "@formant/core/model/IStreamCurrentValueQuery";

import { IAuthStore } from "./IAuthStore";
import {
    IStreamCurrentValueStore,
    StreamCurrentValueMap,
} from "./IStreamCurrentValueStore";
import { StoreCache } from "./StoreCache";

export class StreamCurrentValueStore implements IStreamCurrentValueStore {
    private listCache = new StoreCache<IScopeFilter, IStreamCurrentValue[]>({
        staleIntervalMs: 1 * duration.second,
        isEqual: equals,
    });

    constructor(
        private streamCurrentValueClient: StreamCurrentValueClient,
        private authStore: IAuthStore,
    ) {}

    list(filter: IScopeFilter): IStreamCurrentValue[] | undefined {
        return this.listCache.get(
            filter,
            async () =>
                await this.streamCurrentValueClient.list(
                    await this.authStore.token(),
                    filter,
                ),
        );
    }

    fetch(filter: IStreamCurrentValueQuery): Promise<IStreamCurrentValue[]> {
        return this.listCache.getAsync(
            filter,
            async () =>
                await this.streamCurrentValueClient.list(
                    await this.authStore.token(),
                    filter,
                ),
        );
    }

    map(filter: IScopeFilter): StreamCurrentValueMap | undefined {
        return this.list(filter)?.reduce<StreamCurrentValueMap>((sum, item) => {
            const { deviceId, streamName } = item;
            if (sum[deviceId] === undefined) {
                sum[deviceId] = {};
            }
            if (
                sum[deviceId][streamName] === undefined ||
                sum[deviceId][streamName].currentValueTime <
                    item.currentValueTime
            ) {
                sum[deviceId][streamName] = item;
            }
            return sum;
        }, {});
    }

    async refresh(filter: IScopeFilter): Promise<void> {
        return this.listCache.refresh(
            filter,
            async () =>
                await this.streamCurrentValueClient.list(
                    await this.authStore.token(),
                    filter,
                ),
        );
    }
}
